import { Filters, Scrollbar } from "@kohler-dsm-library/kohler-core"
import "@/components/ProductList/v3/styles/ProductList.module.scss"
import { filtersUiPropTypes } from "@/propTypes/plp"

const FiltersUI = ({
  propsFilters = {},
  propsScroll = {},
  propsSortUI = {},
  isMobileViewport = false,
}) => {
  return (
    <>
      {isMobileViewport ? (
        <Filters
          {...propsFilters}
          sortDropdownProps={propsSortUI?.sortDropdownProps}
        />
      ) : (
        <Scrollbar {...propsScroll}>
          <Filters
            {...propsFilters}
            sortDropdownProps={propsSortUI?.sortDropdownProps}
          />
        </Scrollbar>
      )}
    </>
  )
}

FiltersUI.propTypes = filtersUiPropTypes

export default FiltersUI
